import { useEffect, useState, Fragment } from "react";
// @mui
import {
	Button,
	MenuItem,
	Container,
	Grid,
	Typography,
	InputLabel,
	FormControl,
	Box,
	TextField,
	Tabs,
	Tab,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Tooltip,
	FormControlLabel,
	Checkbox,
	Avatar,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Select from "@mui/material/Select";
import axios from "axios";
import moment from "moment";
import { tooltipClasses } from "@mui/material/Tooltip";
import { useNavigate, useSearchParams } from "react-router-dom";
import Iconify from "../iconify";
import AssetsDialog from "./AssetsDialog";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TEAMS } from "src/constants/teams";
// ----------------------------------------------------------------------

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}
function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 1, paddingTop: 3 }}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}


const HtmlTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: "#f5f5f9",
		color: "rgba(0, 0, 0, 0.87)",
		maxWidth: 220,
		fontSize: theme.typography.pxToRem(12),
		border: "1px solid #dadde9",
	},
}));

const InputTooltip = ({ imgPath }) => (
	<HtmlTooltip
		title={
			<Fragment>
				<img src={imgPath} alt="login" />
			</Fragment>
		}
	>
		<Iconify icon="eva:info-outline" sx={{}} />
	</HtmlTooltip>
);
const dateFormat = "YYYY-MM-DD HH:mm:ss";
const defaultState = {
	title: "",
	prize_image_en: null,
	league_type: "CUSTOM",
};
export default function SearchDialog(props) {
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const [league, setLeague] = useState(defaultState);
	const [assetsTarget, setAssetsTarget] = useState(null);

	useEffect(() => {
		if (props.league !== null) {
			setLeague(props.league);
		}
	}, [props]);
	const handleChange = (e) => {
		const { id, value } = e.target;

		setLeague((prevState) => ({
			...prevState,
			[id]: value,
		}));
	};

	const onSuccess = () => {
		setLeague(defaultState);
		props.onSuccessHandler(league);
		props.onClose();

	};
	const onCancel = () => {
		setLeague(defaultState);
		props.onClose();
	};
	const onChoseAsset = (assetUrl) => {
		setLeague((prevState) => ({
			...prevState,
			[assetsTarget]: assetUrl,
		}));
		setAssetsTarget(null);
	};
	const onCloseAssetsDialog = (assetUrl) => {
		setAssetsTarget(null);
	};
	const handleChangetype = (event) => {
		setLeague((prevState) => ({
			...prevState,
			league_type: event.target.value,
		}));
	};

	const handleChangeTeamId = (event) => {
		setLeague((prevState) => ({
			...prevState,
			league_team_id: event.target.value,
		}));
	};
	return (
		<>
			{assetsTarget === null ? (
				<Dialog
					open={props.open}
					onClose={() => {}}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">
						Search Friends League
					</DialogTitle>
					<DialogContent>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<TextField
									id="title"
									label="Title"
									fullWidth
									value={league.title}
									variant="standard"
									onChange={handleChange}
								/>
							</Grid>

						</Grid>
					</DialogContent>
					<DialogActions>
						<Button onClick={() => onCancel()}>Cancel</Button>
						<Button
							onClick={() => onSuccess()}
							autoFocus
							disabled={!league.title}
						>
							Search
						</Button>
					</DialogActions>
				</Dialog>
			) : (
				<AssetsDialog onSuccess={onChoseAsset} onClose={onCloseAssetsDialog} />
			)}
		</>
	);
}
